export default __webpack_public_path__ + "static/media/linkedin_icon.d096a80e.svg";